import { features } from '@/mocks/homeMocks';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6 scroll-mt-20 text-center">
            为什么选择虫虫漫画
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {features.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 text-center"
              >
                <div className="w-12 h-12 mx-auto mb-4 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className={`${item.icon} text-xl text-primary-500`}></i>
                </div>
                <h3 className="text-sm md:text-base text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}